export const validateIdentityDocument = (nifToValidate: string): boolean => {
  const DNI_REGEX = /^(\d{8})([A-Z])$/;
  const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
  const NIE_REGEX = /^[XYZ]\d{7}[A-Z]$/;

  let document = nifToValidate.toUpperCase().replace(/\s/g, '');
  let isValid = false;

  if (DNI_REGEX.test(document)) {
    isValid = validateDni(document);
  } else if (NIE_REGEX.test(document)) {
    isValid = validateNie(document);
  } else if (CIF_REGEX.test(document)) {
    isValid = validateCif(document);
  }

  return isValid;
};

const validateDni = (dni: string): boolean => {
  const dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const numbers = parseInt(dni.slice(0, 8), 10);
  const letter = dni.charAt(8);

  return dniLetters[numbers % 23] === letter;
};

const validateNie = (nie: string): boolean => {
  const prefix = nie.charAt(0);
  let numericNie = nie;

  switch (prefix) {
    case 'X':
      numericNie = `0${nie.slice(1)}`;
      break;
    case 'Y':
      numericNie = `1${nie.slice(1)}`;
      break;
    case 'Z':
      numericNie = `2${nie.slice(1)}`;
      break;
    default:
      return false;
  }

  return validateDni(numericNie);
};

const validateCif = (cif: string): boolean => {
  const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
  const match = cif.match(CIF_REGEX);


  
  if (!match) return false;

  const letter = match[1]; // Letra inicial del CIF
  const digits = match[2]; // Parte numérica
  const control = match[3]; // Control (dígito o letra)


  let evenSum = 0;
  let oddSum = 0;

  // Cálculo de sumas pares e impares
  for (let i = 0; i < digits.length; i++) {
    const digit = parseInt(digits[i], 10);
    if (i % 2 === 0) {
      const double = digit * 2;
      const adjusted = double > 9 ? double - 9 : double;
      oddSum += adjusted;
    } else {
      evenSum += digit;
    }
  }

  const totalSum = evenSum + oddSum;
  const controlDigit = (10 - (totalSum % 10)) % 10;
  const controlLetter = 'JABCDEFGHI'[controlDigit];


  if ('ABEH'.includes(letter)) {
    return control === controlDigit.toString();
  } else if ('KPQS'.includes(letter)) {
    return control === controlLetter;
  } else {
    return control === controlDigit.toString() || control === controlLetter;
  }
};

